if (!customElements.get('geosort-growth-stories')) {
  customElements.define('geosort-growth-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.viewport = this.querySelector('.gs-stories-viewport');
      this.grid = this.querySelector('.gs-stories-grid');
      this.cards = [...this.querySelectorAll('.gs-story')];
      this.more = this.querySelector('[data-stories-more]');
      this.initial = Math.max(1, Number(this.dataset.initial) || 4);
      this.expanded = false;
      this.transitionId = 0;
      this.cards.slice(this.initial).forEach(card => { card.hidden = true; });
      for (const card of this.cards) {
        card.addEventListener('pointerup', event => {
          if (event.pointerType === 'mouse' || event.target.closest('button,a')) return;
          const reveal = !card.classList.contains('is-tapped');
          this.cards.forEach(item => item.classList.toggle('is-tapped', item === card && reveal));
        }, options);
      }
      document.addEventListener('pointerdown', event => {
        if (!event.target.closest('.gs-story')) this.cards.forEach(card => card.classList.remove('is-tapped'));
      }, options);
      if (this.more) {
        this.more.hidden = false;
        this.more.addEventListener('click', () => this.toggle(), options);
      }
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.heightAnimation?.finish();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target) && event.target.closest('.gs-story')?.hidden && !this.expanded) this.toggle();
      }, options);
    }
    async toggle() {
      const transitionId = ++this.transitionId;
      const start = this.viewport.getBoundingClientRect().height;
      this.heightAnimation?.cancel();
      this.viewport.style.height = `${start}px`;
      this.viewport.style.overflow = 'hidden';
      this.expanded = !this.expanded;
      const extras = this.cards.slice(this.initial);
      if (!this.expanded && extras.some(card => card.contains(document.activeElement))) this.more.focus({ preventScroll: true });
      // Measure the natural grid, then reveal it through the animated viewport.
      // On collapse, keep the cards painted until the viewport has closed.
      extras.forEach(card => { card.hidden = !this.expanded; card.inert = !this.expanded; });
      const end = this.grid.getBoundingClientRect().height;
      extras.forEach(card => { card.hidden = false; });
      this.more.setAttribute('aria-expanded', String(this.expanded));
      this.more.querySelector('span').textContent = this.expanded ? this.more.dataset.lessLabel : this.more.dataset.moreLabel;
      if (!this.motion.matches) {
        this.heightAnimation = this.viewport.animate([{ height: `${start}px` }, { height: `${end}px` }], {
          duration: 950, easing: 'cubic-bezier(.25,.8,.25,1)', fill: 'forwards'
        });
        await this.heightAnimation.finished.catch(() => {});
      }
      if (transitionId !== this.transitionId) return;
      extras.forEach(card => { card.hidden = !this.expanded; });
      this.viewport.style.height = '';
      this.viewport.style.overflow = '';
      this.heightAnimation?.cancel();
      this.heightAnimation = null;
      this.querySelectorAll('geosort-story-video').forEach(player => player.update?.());
      if (!this.expanded && this.more.getBoundingClientRect().top < 0) {
        this.more.scrollIntoView({ block: 'center', behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
    }
    disconnectedCallback() {
      this.transitionId++;
      this.heightAnimation?.cancel();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
